import React from 'react';
import styles from './Badge.module.css';

const DOT_COLORS = {
  active:    '#4F9B6F',
  paused:    '#A07C30',
  draft:     '#686868',
  completed: '#6E62A8',
  running:   '#4878B0',
  sending:   '#4878B0',
  scheduled: '#A07C30',
  cancelled: '#CC5555',
  winner:    '#4F9B6F',
  android:   '#4F9B6F',
  ios:       '#4878B0',
  both:      '#6E62A8',
};

class Badge extends React.Component {
  render() {
    const { status, dot, children } = this.props;

    const cls = [
      styles.badge,
      styles[status] || styles.draft,
    ].join(' ');

    return (
      <span className={cls}>
        {dot && (
          <span
            className={styles.dot}
            style={{ background: DOT_COLORS[status] || '#888' }}
          />
        )}
        {children}
      </span>
    );
  }
}

export default Badge;
